/* Polyfills */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { formHelpers } from './formHelpers';
import { restrictedAccess } from './restrictedAccess';
import { FormAjaxifier } from './form/FormAjaxifier';
import { modalUtils } from './modalUtils';
import { Theme } from './theme';
import { carousel } from './blocks/carousel';
import { video } from './blocks/video';
import { memberMenu } from './membership/memberMenu';
import { membershipForm } from './membership/form';
import { membershipCompany } from './membership/company';
import { toasts } from './toasts';
import { autocomplete } from './form/autocomplete';
import { imageFieldPreview } from './imageFieldPreview';
import { events } from './events';
import { resources } from './resources';
import { members } from './members';
import { moveTo } from './moveTo';
import { tinyslider } from './tinyslider';

document.addEventListener( 'DOMContentLoaded', function() {
	// Form helpers
	formHelpers.init();
	// Enable AJAX submit on specific forms
	document.querySelectorAll( 'form.ajax-form' ).forEach( ( form ) => {
		FormAjaxifier.ajaxify( form );
	} );
	// Restricted access
	restrictedAccess.init();
	// Modals
	modalUtils.init();
	// Open auto modal if any (from URL hash)
	modalUtils.openAutoModal();
	// Init banner background
	Theme.initBannerBg();
	// Init mobile menu
	Theme.initMobileMenu();
	// Bootstrap Carousel
	carousel.init();
	// Video block
	video.init();
	// Member menu
	memberMenu.init();
	// Membership functions
	membershipCompany.init();
	// Membership form
	membershipForm.init();
	// Toasts
	toasts.init();
	// Autocomplete
	autocomplete.initContactAutocomplete();
	// Image field preview
	imageFieldPreview.init();
	// Members List
	members.init();
	// Events List
	events.init();
	// Resources List
	resources.init();
	// Move elements on load
	moveTo.init();
	// Tiny slider
	tinyslider.init();
}, false );
